import ListHoc from "./ListHoc";

export default ListHoc;